export const OFFERING_CURRENCY = {
  CAD: 'CAD'
};
